import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21 10a9 9 0 0 0-18 0c0 3.838 2.963 8.17 9 12.933 6.037-4.763 9-9.095 9-12.933zm-8.38 13.718a1 1 0 0 1-1.24 0C5.128 18.784 2 14.212 2 10 2 4.477 6.477 0 12 0s10 4.479 10 10c0 4.212-3.127 8.784-9.38 13.718zM12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
});

var SvgLocationMarker = function SvgLocationMarker(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgLocationMarker;